var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_c('i',{staticClass:"fa fa-copyright mr-1"}),_c('span',{staticClass:"copyright__text"},[_vm._v(" "+_vm._s(_vm.copyright))])])}
var staticRenderFns = []

export { render, staticRenderFns }